module.exports = __webpack_public_path__ + "static/img/014酒庄官网5.d0db664.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/picImgs/014酒庄官网5.jpg
// module id = wb7T
// module chunks = 0